import {Button,Dialog,DialogActions,DialogContent,DialogTitle} from "@mui/material";
import Delete from "@mui/icons-material/Delete";

import Loading from "../../../Loading";
import Error from "../../../components/Error";
import useDB from "../../../hooks/useDB";
import { weekdays } from "../../../../../enums";
import { CenterContext, LanguageContext } from "../../../../../Context";
import { useContext } from "react";
import SelectFromList from "../../../components/SelectFromList";
import AddButton from "../../../components/AddButton";
import TimeClock from "../../../components/TimeClock";
import mut from "../../../hooks/mut";

export default function EditDays(props) {
    const { open, setOpen, lesson, day  } = props;
    const [htClass, setHtClass, error, loading] = useDB(`/htClass/${lesson.classId}`)
    if (loading) return <Loading />
    if (error) return <Error />
  
    const addClassDay = () => {
        setHtClass(prev=>({...prev, classDays: [...prev.classDays, {}]}))
    }
  
    const disabled = () => {
      
        for (let cd of htClass.classDays) {
            if(!cd.day || !cd.room || !cd.startTime || !cd.endTime) return true
        }
        return false
    }

    console.log(htClass)
  return (
    <Dialog open={open} fullWidth maxWidth="lg">
          <DialogTitle>Edit days for {lesson.name}, {htClass.classDays.length} lesson{htClass.classDays.length === 1 ? "" : "s"} per week</DialogTitle>
          <DialogContent className="flex flex-col items-center">
              {htClass.classDays
                  .sort((a, b) => (a.day > b.day) ? 1 : ((b.day > a.day) ? -1 : 0))
                  .map(cd => <DrawDay classDay={cd} key={cd._id} setHtClass={setHtClass} htClass={htClass} days={htClass.classDays.map(cd => cd.day)} />)}
              <AddButton action={addClassDay} />
      </DialogContent>
      <DialogActions>
        <Button color="error" onClick={() => setOpen(false)}>Close</Button>
              <Button color="success" onClick={async () => {
                  let res = await mut("post", `/update-classdays/${htClass._id}`, {
                    classDays: htClass.classDays, tDate: day
                  });
                  setOpen(false)
              }}
              disabled={disabled()}>Go</Button>
      </DialogActions>
    </Dialog>
  );
}

function DrawDay({ classDay, htClass, setHtClass, days }) {
    const { language } = useContext(LanguageContext)
    const { center } = useContext(CenterContext)
    const l = center.locations.find(l => l._id === htClass.location)
    const update = (value, field) => {
        let htc = {...htClass, classDays: htClass.classDays.map(cd => cd._id === classDay._id ? { ...cd, [field]: value } : cd)}
        setHtClass(htc)
    }

    const deleteCD = (_id) => {
        let htc = {...htClass, classDays: htClass.classDays.filter(cd => cd._id !== _id)}
        setHtClass(htc)
    }
    return (
      <div className="flex gap-5 items-center">
        <div className="flex flex-col gap-3 w-30">
          <SelectFromList
            choices={makeChoices(language,days, classDay.day)}
            value={classDay.day}
            setValue={(value) => update(value, "day")}
                    size="small"
                    label="Day"
          />
          <SelectFromList
            choices={l.rooms}
            value={classDay.room}
            setValue={(value) => update(value, "room")}
                    size="small"
                    label="Room"
          />
        </div>

        <TimeClock
          value={classDay.startTime}
                setValue={(value) => update(value, "startTime")}
                label="startTime"
        />
        <TimeClock
          value={classDay.endTime}
                setValue={(value) => update(value, "endTime")}
                label="finishTime"
        />

        <div>
          <Delete action={() => deleteCD(classDay._id)} />
        </div>
      </div>
    );
    
}

function makeChoices(language, days, current) {

  const choices = weekdays.map((w, i) => ({ _id: i, name: w[language] }));
   const c = choices.filter((w) => !days.includes(w._id) && w._id !== current);
if(!current)  return c

  return [{_id: current, name: weekdays[current][language]},...c] 
}
